import * as classnames from 'classnames'
import * as React from 'react'

import CartIcon from '../../../components/icons/cart'
import Button from '../../buttons/button'
import { IItemCard } from '../interface'

import * as styles from './lockupAddToCartButton.module.css'

interface IProps extends IItemCard {
  icon?: boolean
}

const LockupAddToCartButton = ({ item, onAddToCart, icon }: IProps) => {
  const classNames = classnames(styles.root, { [styles.fullWidth]: !icon })

  return (
    <Button
      role="button"
      altPrimary
      href={`/cart/configure_before_adding/${item.id}`}
      onClick={onAddToCart}
      active={item.ui.isInCart}
      className={classNames}
      target="_blank"
    >
      {icon ? <CartIcon /> : 'Add To Cart'}
    </Button>
  )
}

export default LockupAddToCartButton
